import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import { ALL_ROUTES } from '../../global/Constants';
import './login-with-otp.css';
import { LOGO, LOGIN_SIDE_IMAGE } from '../../global/Icons';
import ApiServices from '../../providers/ApiServices';
import Utilities from '../../global/Utilities';
import Loader from '../common/loader/Loader';

class LoginWithOTPPage extends Component {

    constructor(props) {
        super(props)
        this.goBack = this.goBack.bind(this);
        this.state = {
            errorMsg: "",
            loading:false,
            fields: {
                email: "",
            }
        }
    }

    goBack() {
        this.props.history.goBack();
    }

    componentDidMount() {
        document.getElementById("sendOTP").disabled = true;
    }

    _getFieldValue(fieldName, defaultValue) {
        const { fields } = this.state;
        let value = fields[fieldName];
        if (value === null || (typeof value === 'undefined')) {
            value = defaultValue;
        }
        return value;
    }

    _handleValueChange = (field, e) => {
        let fields = this.state.fields;
        fields[field] = e.target.value;
        this.setState({ fields })
        var numberPattern = new RegExp(/^[0-9\b]+$/);
        var emailPattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
        const email = this._getFieldValue("email", "");
        if (!numberPattern.test(email)) {
            document.getElementById("sendOTP").disabled = (!emailPattern.test(email));
        } else {
            document.getElementById("sendOTP").disabled = (email.length < 8);
        }

    }

    _performSendOTP = (e) =>{
        e.preventDefault();
        this.setState({loading:true });
        const { email } = this.state.fields;
        var body = JSON.stringify({
            userId: email,
            isLoginOtp: true,
        });
        try{
            ApiServices.logIn(body)
            .then(response=>{
                this.setState({loading:false });
                var status = response.success;
                if(status){
                    this.props.history.push({
                        pathname: ALL_ROUTES.OTP_ROUTE,
                        state: { email: email, isForgot:false, token:response.data.token }
                    })
                }else{
                    Utilities.LogPrint("Status",response.message);
                    if(response.message!==undefined && response.message ){
                    this.setState({
                        errorMsg: response.message
                    });
                }
                }
            }).catch(error=>{
                this.setState({ loading: false,errorMsg:error });
            });
        }catch(error){
            this.setState({ loading: false,errorMsg:error });
        }
    }

    render() {
        const {  errorMsg,loading } = this.state;
        return (
            <div className="sign-page input-dh">
                <div className="row mx-auto">
                    <div className="col-md-6 col-12 homeimg pr-5">
                        <img src={LOGIN_SIDE_IMAGE} className="img-fluid" alt="" />
                    </div>
                    <div className="col-md-6 col-12 pl-md-0 pr-md-5">
                        <div className="row">
                            <div className="col-12 signin-max-489">
                                <div className="logo">
                                    <i className="customic ic-back-button mb-3" onClick={()=>this.goBack()}></i><br />

                                    <img src={LOGO} className="img-fluid" alt="" />
                                </div>

                                <h5>Login with OTP</h5>
                                <form action="">
                                    <div className="form-group">
                                        <input type="email" className="form-control" placeholder="Mobile / Email" onChange={this._handleValueChange.bind(this, "email")} />
                                    </div>
                                    <p className="info-paragraph">Enter mobile number / email address registered with us.</p>
                                    <span
                                            className={
                                                errorMsg.length > 0 ? "error-msg" : "d-none error-msg"
                                            }
                                        >
                                            {errorMsg}
                                        </span>
                                    <button id="sendOTP" className="btn btn-primary w-100 mb-2 mt-md-4" onClick={this._performSendOTP}>SEND OTP</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                {loading ? <Loader /> : null}
            </div>
        )
    }
}

export default withRouter(LoginWithOTPPage)